import { gql } from '@apollo/client';

export const GET_TEAM_TEMPLATE_ANALYTICS = gql`
  query GetTeamTemplateAnalytics(
    $teamId: ID!
    $dateFrom: ISO8601DateTime!
    $dateTo: ISO8601DateTime!
    $formats: [String!]
  ) {
    teamTemplateAnalytics(
      teamId: $teamId
      dateFrom: $dateFrom
      dateTo: $dateTo
      formats: $formats
    ) {
      templates {
        id
        name
        format
        totalUses
        lastUsedAt
        usageTrend {
          date
          count
        }
      }
      aggregateTrend {
        date
        count
      }
      totalUsage
    }
  }
`;